import { useContext, useState } from 'react';
import { Container, Button, Grid, CircularProgress } from '@material-ui/core';
import { LockOpenOutlined as UnLockIcon } from '@material-ui/icons';
import { authContext } from 'helpers/services';
import { Field, Form, Formik } from 'formik';
import * as yup from 'yup';
import { TextField } from 'formik-material-ui';
import { useLocation } from 'react-router';
import { Page } from 'components';


let ResetPassword = () => {
    let location = useLocation<any>();

    let authService = useContext(authContext);

    let [isLoading, setLoading] = useState(false);

    let resetPasswordSchema = yup.object().shape({
        code: yup.string().default('').required("Wrong code"),
        email: yup.string().default('').required("Email is mandatory"),
        password: yup.string().default('').required("You have to provide new password"),
        passwordConfirm: yup.string()
            .oneOf([yup.ref('password'), null], "Passwords does not match")
            .required("You have to confirm new password")
            .default('')
    })


    return (
        <Container maxWidth="sm">
            <Page
                useHeader={true}
                isLoading={false}
                title="Reset password"
                subtitle="Please set the code that we have sent to your email and new password"
            >
                <Formik
                    initialValues={{
                        ...resetPasswordSchema.getDefault(),
                        email: location.state?.email || ''
                    }}
                    validationSchema={resetPasswordSchema}
                    onSubmit={async (values, action) => {
                        setLoading(true);
                        let res = await authService.forgotPasswordSubmit(values.email, values.code, values.password);
                        if (res === false) {
                            action.setSubmitting(false);
                            setLoading(false);
                        }
                    }}
                >
                    <Form>
                        <Grid container>
                            <Grid item xs={12}>
                                <Field
                                    component={TextField}
                                    name="email"
                                    label="Email"
                                    variant="outlined"
                                    type="email"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Field
                                    component={TextField}
                                    name="code"
                                    label="Code"
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Field
                                    component={TextField}
                                    name="password"
                                    label="Password"
                                    variant="outlined"
                                    type="password"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Field
                                    component={TextField}
                                    name="passwordConfirm"
                                    label="Confirm Password"
                                    variant="outlined"
                                    type="password"
                                />
                            </Grid>
                            <Grid item xs>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="secondary"
                                    disabled={isLoading}
                                    startIcon={isLoading ? <CircularProgress size={20} /> : <UnLockIcon />}
                                >
                                    Reset password
                                </Button>
                            </Grid>
                        </Grid>
                    </Form>
                </Formik>
            </Page>
        </Container>
    )
}

export default ResetPassword;